import { ReactNode } from "react";

import {
    StyledProductTagDropout,
    StyledProductTagMML,
    StyledProductTagNew,
    StyledProductTags,
    StyledProductTagSpecial,
} from "./ProductTags.styled";

type SpecialTaskType = "dropout" | string;

interface ProductTagsProps {
    tags: {
        isNew?: boolean;
        isSpecialTask?: SpecialTaskType | null;
        isMML?: boolean;
        productPlan?: boolean;
        additionalPlan?: boolean;
    };
}

const SPECIAL_TASK_MAP: Record<string, ReactNode> = {
    dropout: <StyledProductTagDropout>Вибуття</StyledProductTagDropout>,
    default: <StyledProductTagSpecial>Спецзадача</StyledProductTagSpecial>,
};

export const ProductTags = ({ tags }: ProductTagsProps) => {
    const { isNew, isSpecialTask, isMML, productPlan, additionalPlan } = tags;

    const hasAnyTag =
        isNew || isSpecialTask || isMML || productPlan || additionalPlan;

    if (!hasAnyTag) return null;

    const showProductPlan = productPlan && !isMML;
    const showAdditionalPlan = additionalPlan && !productPlan && !isMML;

    return (
        <StyledProductTags>
            {isNew && <StyledProductTagNew>NEW</StyledProductTagNew>}

            {isSpecialTask &&
                (SPECIAL_TASK_MAP[isSpecialTask] ?? SPECIAL_TASK_MAP.default)}

            {isMML && <StyledProductTagMML>MML</StyledProductTagMML>}

            {showProductPlan && <StyledProductTagMML>План</StyledProductTagMML>}

            {showAdditionalPlan && (
                <StyledProductTagMML>План+</StyledProductTagMML>
            )}
        </StyledProductTags>
    );
};
